/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidacyIndex } from '../../axios/candidacyIndex'
import type { CandidacyIndexError, CandidacyIndexPathParams, CandidacyIndexResponse } from '../../types/CandidacyIndex'

export const candidacyIndexQueryKey = (organisation: CandidacyIndexPathParams['organisation']) =>
	[{ url: '/candidate-center/organisations/:organisation/candidacies', params: { organisation } }] as const

export type CandidacyIndexQueryKey = ReturnType<typeof candidacyIndexQueryKey>

/** @see backend/nexus/modules/CandidateCenter/Http/Controllers/CandidacyController.php CandidacyController::index */
export function candidacyIndexQueryOptions(
	organisation: CandidacyIndexPathParams['organisation'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		CandidacyIndexResponse,
		AxiosError<CandidacyIndexError>,
		CandidacyIndexResponse,
		CandidacyIndexQueryKey
	>({
		queryKey: candidacyIndexQueryKey(organisation),
		queryFn: ({ signal }) => candidacyIndex(organisation, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/CandidateCenter/Http/Controllers/CandidacyController.php CandidacyController::index */
export function useCandidacyIndex<TSelectData = CandidacyIndexResponse>(
	organisation: CandidacyIndexPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					CandidacyIndexResponse,
					AxiosError<CandidacyIndexError>,
					TSelectData,
					CandidacyIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<CandidacyIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...candidacyIndexQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/CandidateCenter/Http/Controllers/CandidacyController.php CandidacyController::index */
export function useCandidacyIndexSuspense<TSelectData = CandidacyIndexResponse>(
	organisation: CandidacyIndexPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					CandidacyIndexResponse,
					AxiosError<CandidacyIndexError>,
					TSelectData,
					CandidacyIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<CandidacyIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...candidacyIndexQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
